import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import Layout from "../../components/Layout"
import * as userApis from "../../utilities/apis/user"

const Users = () => {
  const navigate = useNavigate()
  const { token, permissions } = useSelector(state => state.user)
  const [users, setUsers] = useState([])

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await userApis.deleteUser(token, id)
      if (!response.status) throw new Error(response.message)

      setUsers((previous) => [...previous.filter(x => x.id !== id)])
    } catch (error) {
    }
  }

  const getUsers = async () => {
    try {
      const response = await userApis.getUsers(token, "")
      if (!response.status) throw new Error(response.message)

      setUsers(response.users)
    } catch (error) {
    }
  }

  useEffect(() => {
    getUsers()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Users</p>
            <div className="d-flex gap-2">
              {permissions["READ_ROLES"] && <Link to="/dashboard/roles" className="btn btn-secondary rounded-4">Manage Roles</Link>}
              {permissions["CREATE_USER"] && <Link to="/dashboard/user" className="btn btn-theme rounded-4">New</Link>}
            </div>
          </div>

          <div className="border rounded-4">
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "45%" }} className="align-middle">Name</th>
                  <th scope="col" style={{ width: "45%" }} className="align-middle">Role</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((row) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">{row.name}</td>
                      <td className="align-middle text-capitalize">{row.role.name}</td>
                      <td className="align-middle text-center">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["UPDATE_USER"] && <Link to={`/dashboard/user?id=${row.id}`}><i className="far fa-edit"></i></Link>}
                          {permissions["DELETE_USER"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Users
